import {Model} from '@vuex-orm/core'
import {Stock} from '@/models'
import {Retrocession} from '@/models'
import {Deposant} from "@/models";

export class Article extends Model {
  static entity = 'Article'

  static fields () {
    return {
      id: this.number(null),
      fabriquantMarque: this.string(''),
      designation: this.string(''),
      photos: this.attr(null),
      quantiteDeposee: this.number(null),
      prixAchat: this.number(null),
      softId: this.number(null),
      deposant_id: this.number(null).nullable(),
      stock: this.hasOne(Stock, 'article_id'),
      retrocessions: this.hasMany(Retrocession, 'article_id'),
      deposant: this.belongsTo(Deposant, 'deposant_id'),
      ligne_id: this.number(null)
    }
  }
}
